class SimpleVideo extends HTMLElement {
  constructor() {
    super();
    this.videoDesktop = this.querySelector('.video__desktop-only video');
    this.videoMobile = this.querySelector('.video__mobile-only video');
    this.video = this.getActiveVideo();
    this.pauseButton = this.querySelector('.simple-video__pause-button');
    this.isPaused = false;
    this.videoContainer = this.querySelector('.video__desktop-only, .video__mobile-only') || this;

    // Update video reference when window resizes
    window.addEventListener('resize', () => {
      this.video = this.getActiveVideo();
    });

    if (this.pauseButton && this.video) {
      this.pauseButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.togglePlay();
      });
    }

    // Make the entire video clickable if there's no parent link
    if (this.video && !this.closest('a')) {
      this.videoContainer.addEventListener('click', (event) => {
        // Only trigger if the click wasn't on the pause button
        if (!event.target.closest('.simple-video__pause-button')) {
          this.togglePlay();
        }
      });

      // Add cursor style to indicate it's clickable
      this.videoContainer.style.cursor = 'pointer';
    }
  }

  // Get the active video based on screen size
  getActiveVideo() {
    if (this.videoMobile && window.innerWidth <= 749) {
      return this.videoMobile;
    }
    return this.videoDesktop || this.querySelector('video');
  }

  togglePlay() {
    if (this.video.paused) {
      this.video.play().catch((error) => {
        if (!error || error.name !== 'AbortError') throw error;
      });
      this.isPaused = false;
    } else {
      this.video.pause();
      this.isPaused = true;
    }
    this.updatePauseButtonState();
  }

  updatePauseButtonState() {
    if (this.pauseButton) {
      this.pauseButton.classList.toggle('is-paused', this.isPaused);
    }
  }
}

if (!customElements.get('simple-video')) {
  customElements.define('simple-video', SimpleVideo);
}
